import {
	FormControl,
	FormControlLabel,
	FormHelperText,
	FormLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

interface Props {
	/** `videoConfig.advanceOnVideoEnd`. Absent (an older event) reads as "Show Continue". */
	value: boolean | undefined;
	onChange: (advanceOnVideoEnd: boolean) => void;
}

const CONTINUE = "continue";
const AUTO = "auto";

/**
 * SIMS-9419 — what the participant's app does when a WATCH_VIDEO ends on a credited watch.
 *
 * Sits next to "Min Watch %" in the event form. "Show Continue" is the default (D-9419-1):
 * the participant stays on the video and moves on with Continue. "Go to the next page
 * automatically" is the old behaviour. Either way the participant can go back to the
 * previous page of a compound event; the helper text says so, so a coordinator doesn't
 * read "automatically" as "locked".
 */
export const VideoEndBehaviourField = ({ value, onChange }: Props) => (
	<FormControl data-testid="video-end-behaviour">
		<FormLabel id="video-end-behaviour-label">When the video ends</FormLabel>
		<RadioGroup
			row
			aria-labelledby="video-end-behaviour-label"
			name="advanceOnVideoEnd"
			value={value === true ? AUTO : CONTINUE}
			onChange={(e) => onChange(e.target.value === AUTO)}
		>
			<FormControlLabel
				value={CONTINUE}
				control={<Radio size="small" />}
				label="Show Continue"
			/>
			<FormControlLabel
				value={AUTO}
				control={<Radio size="small" />}
				label="Go to the next page automatically"
			/>
		</RadioGroup>
		<FormHelperText>
			In both cases the participant can go back to the previous page of a
			compound event.
		</FormHelperText>
	</FormControl>
);
